import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeflex/primeflex.css';
import '../../css/index.css';

import React, { useEffect, useState, useMemo } from 'react';

/* ############## PRIME REACT IMPORTS ############## */
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from 'primereact/checkbox';
import BasicConfigIntegration from '../../integrations/BasicConfigIntegration';


const BasicConfig = ({ setForm, formData }) => {
    
    const [business, setBusiness] = useState([]);
    const [language, setLanguage] = useState([]);
    const [features, setFeatures] = useState([]);
    
    const basicConfigIntegration = useMemo(() => new BasicConfigIntegration(), []);


    useEffect(() => {
        Promise.all([
            basicConfigIntegration.getBusiness(),
            basicConfigIntegration.getLanguage(),
            basicConfigIntegration.getFeatures(),
        ])
            .then(([businessData, languageData, featuresData]) => {
                setBusiness((businessData || []).map((item) => item.name));
                setLanguage((languageData || []).map((item) => item.name));
                setFeatures(featuresData || []);
            })
            .catch((error) => {
                console.error('[BasicConfig] Failed to load options:', error);
            });
    }, [basicConfigIntegration]);


    const onInputChange = (e, name) => {
        const val = (e.target.type === 'checkbox') ? (e.checked) : e.target.value;
        let _localForm = { ...formData };
        _localForm[`${name}`] = val;


        // setLocalData(_initial);
        setForm(_localForm);
    }
    const groupedItemTemplate = (option) => {
        return (
            <div className="p-d-flex p-ai-center country-item">
                <div>{option.label}</div>
            </div>
        );
    }
    return (
        <div className="card">
            <div className="p-fluid p-grid">
                <div className="p-field p-col-12 p-md-6">
                    <span className="p-float-label">
                        <InputText value={formData.nameTemplate} onChange={(e) => onInputChange(e, 'nameTemplate')} required autoFocus />
                        <label htmlFor="nameTemplate" >Nome do template*</label>
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <span className="p-float-label">
                        <Dropdown
                            value={formData.businessLine}
                            options={business}
                            onChange={(e) => onInputChange(e, 'businessLine')}
                            placeholder="Selecione o Tipo de Negócio"
                        >
                        </Dropdown >
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <span className="p-float-label">
                        <Dropdown
                            value={formData.templateLanguage}
                            options={language}
                            onChange={(e) => onInputChange(e, 'templateLanguage')}
                            placeholder="Selecione o Idioma do Template"
                        >
                        </Dropdown  >
                    </span>
                </div>
                <div className="p-field p-col-12 p-md-6">
                    <span className="p-float-label">
                        <MultiSelect
                            value={formData.templateFeatures}
                            options={features}
                            inputId="features"
                            onChange={(e) => onInputChange(e, 'templateFeatures')}
                            optionLabel="label"
                            optionGroupLabel="label"
                            optionGroupChildren="items"
                            optionGroupTemplate={groupedItemTemplate}
                            display="chip"
                        >

                        </MultiSelect>
                        <label htmlFor="features">Planos e Recursos</label>
                    </span>
                </div>
                <div className="p-field p-col-6 p-md-6">
                    <span className="p-float-label">
                        <InputText id="description" value={formData.templateDescription} onChange={(e) => onInputChange(e, 'templateDescription')} required autoresize="true" />
                        <label htmlFor="description">Descrição do template*</label>
                    </span>
                </div>
                <div className="p-field p-col-6 p-md-6">
                    <span className="p-float-label">
                        <InputText id="createdBy" value={formData.createdBy} onChange={(e) => onInputChange(e, 'createdBy')} required autoresize="true" />
                        <label htmlFor="createdBy">Criado por *</label>
                    </span>
                </div>
                <div className="p-field p-col-6 p-md-6">
                    <div className="p-field-checkbox">
                        <Checkbox id="onlyCampaigns" onChange={(e) => onInputChange(e, 'onlyCampaigns')} checked={formData.onlyCampaigns}></Checkbox>
                        <label htmlFor="onlyCampaigns">onlyCampaigns</label>
                    </div>
                </div>
            </div>
        </div >
    );
}
export default BasicConfig;